import { render, staticRenderFns } from "./ViPlanDetails.vue?vue&type=template&id=398774d8"
import script from "./ViPlanDetails.vue?vue&type=script&lang=js"
export * from "./ViPlanDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports